import { ISusuarioList, UsuarioList } from '../../types/usuario/UsuarioList';
import { MenuFilho } from '../menuFilho/MenuFilho';
import { ISnoticiaList, NoticiaList } from '../noticia/Noticia';

export interface TipoPublicacaoOficial {
  id?: string;
  nome: string;
  descricao?: string;
  isVereador?: boolean;
  isMenuisMenuisMenuisMenuisMenu?: boolean;
  dataHoraCriacao?: Date | string;
  usuario?: UsuarioList;
}
export const IStipoPublicacaoOficial: TipoPublicacaoOficial = {
  id: '',
  nome: '',
  descricao: '',
  dataHoraCriacao: '',
  usuario: ISusuarioList
};
export interface TipoPublicacaoOficialList {
  id?: string;
  nome: string;
  descricao?: string;
  isVereador?: boolean;
  dataHoraCriacao?: Date | string;
  usuario?: UsuarioList;
}
export const IStipoPublicacaoOficialList: TipoPublicacaoOficialList = {
  id: '',
  nome: '',
  descricao: '',
  dataHoraCriacao: '',
  usuario: ISusuarioList
};

export interface TipoPublicacaoOficialDTO {
  id: string;
  nome: string;
  descricao?: string;
  isVereador?: boolean;
}
export const IStipoPublicacaoOficialDTO: TipoPublicacaoOficialDTO = {
  id: '',
  nome: '',
  descricao: '',
  isVereador: false
};
